<template>
  <div class="content h-100">
    <nav class="navbar navbar-dark bg-dark w-100">
      <div class="row align-items-center w-100">
        <div class="col-12 col-sm-2 col-md-2">
          <NavBrand />
        </div>
        <div class="col-12 col-sm-8 col-md-8">
          <ItemName @generate="generateArtifact" />
        </div>
        <div class="col-12 col-sm-2 col-md-2 text-right">
          <a
            class="btn btn-link text-light btn-sm basic-tour"
            @click="startTour"
            title="Ficou com dúvidas sobre como utilizar o martelo arcano? Clica aqui ;)"
          >
            <i class="fa fa-info-circle"></i> Guia
          </a>
        </div>
      </div>
    </nav>
    <div class="item-generator">
      <div class="editor">
        <ItemPreview ref="itemPreview">
          <ItemOptions
            class="options-left"
            title="Propriedades do artefato"
          >
            <ItemBackOptions />
          </ItemOptions>
          <ItemOptions
            class="options-right"
            title="Exterior do artefato"
          >
            <ItemCoverOptions />
          </ItemOptions>
        </ItemPreview>
      </div>
      <div class="export-list">
        <GeneratedItems class="h-100" />
      </div>
    </div>
    <div class="credits">
      <span>
        Criado por
        <a href="https://kacianoghelere.github.io/" target="_blank">Kaciano Ghelere</a>
        (v1.1.0)
      </span>
      <span>Encontrou alguma ruptura no tecido arcano? Chame o arcanista:
        <a href="mailto:kacianoghelere@gmail.com">kacianoghelere@gmail.com</a>
      </span>
    </div>
    <TourGuide />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  import NavBrand from './NavBrand.vue';
  import GeneratedItems from './GeneratedItems.vue';
  import ItemBackOptions from './ItemBackOptions.vue';
  import ItemCoverOptions from './ItemCoverOptions.vue';
  import ItemName from './ItemName.vue';
  import ItemOptions from './ItemOptions.vue';
  import ItemPreview from './ItemPreview.vue';
  import TourGuide from './TourGuide.vue';

  export default {
    name: 'ItemGenerator',
    components: {
      NavBrand,
      GeneratedItems,
      ItemBackOptions,
      ItemCoverOptions,
      ItemName,
      ItemOptions,
      ItemPreview,
      TourGuide
    },
    computed: {
      ...mapState({
        itemName: ({ item }) => item.name
      })
    },
    methods: {
      ...mapActions([ 'setGeneratedItem' ]),
      async generateArtifact() {
        if (!this.itemName) {
          // eslint-disable-next-line no-undef
          swal({
            title: 'Dê um nome para o seu artefato!',
            text: 'Nomes definem o propósito e dão forma as coisas, mesmo que de uma maneira abstrata...',
            icon: 'warning'
          })

          return
        }

        const el = this.$refs.itemPreview.$refs.itemCards

        const canvas =  await this.$html2canvas(el)

        this.setGeneratedItem({
          name: `${this.itemName}.jpg`,
          url: canvas.toDataURL('image/jpeg'),
          width: canvas.width,
          height: canvas.height
        })
      },
      startTour() {
        this.$tours['basicTour'].start()
      }
    }
  }
</script>

<style lang="scss" scoped>
  $first: #aa4b6b;
  $second: #6b6b83;
  $third: #3b8d99;

  .content {
    background-image: linear-gradient(45deg, rgba($first, .65), rgba($second, .65), rgba($third, .65)),
                      url("../../public/assets/editor-background.jpg");
    background-repeat: repeat, repeat-y;
    background-size:  cover;
  }

  .navbar {
    background-image: linear-gradient(to left, darken($first, 20%), darken($second, 20%), darken($third, 20%));
    min-height: 60px;

    .navbar-brand {
      font-family: "Cinzel";
    }
  }

  .item-generator {
    display: flex;
    flex-direction: column;
    height: calc(100% - 80px) !important;
    position: relative;
    width: 100%;

    @media (max-width: 576px) {
      height: auto !important;
    }

    .editor {
      background: transparent;
      background-repeat: repeat, no-repeat;
      background-position: center;
      background-size: 100% ;
      display: flex;
      height: calc(100% - 180px);
      position: relative;
      width: 100%;

      @media (max-width: 576px) {
        height: auto !important;
      }
    }

    .export-list {
      min-height: 180px;
      width: 100%;
      z-index: 2;

      @media (max-width: 576px) {
        min-height: 0;
      }
    }
  }

  .credits {
    align-items: center;
    background-color: white;
    background-image: linear-gradient(45deg, rgba($first, .2), rgba($second, .2), rgba($third, .2));
    border-top: 1px solid #ddd;
    box-sizing: border-box;
    color: #888 !important;
    display: flex;
    font-size: 70%;
    height: 20px;
    justify-content: space-between;
    padding: 0 1em;
    text-align: center;

    a {
      color: #666 !important;
    }
  }

  .bg-options {
    background-color: rgba(#444, .5);
  }
</style>